export default __webpack_public_path__ + "3235eaddb4b77ab436b49e624345924b.png";